import { render, staticRenderFns } from "./coreText.vue?vue&type=template&id=6cdfea0b"
import script from "./coreText.vue?vue&type=script&lang=js"
export * from "./coreText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports